import React, { useEffect, useState, useCallback, useRef } from "react";
import "./ExamPreparationCards.scss";
import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import File from "../../Assets/images/quesionbank.png";
import { getCourseByQuestionBank } from "../../services/courseServices";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";


const QuestionBankCompPage = () => {
  const sectionRef = useRef(null);
  const [storyData, setStoryData] = useState({
    data: [],
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
  });
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async (searchTerm = '', page = 1) => {
    setIsLoading(true);
    try {
      const response = await getCourseByQuestionBank({
        search: searchTerm,
        page,
        limit:5
      });

      if (response?.isSuccess) {
        setStoryData({
          data: response.data || [],
          currentPage: response.pagination?.page || page,
          totalPages: response.pagination?.totalPages || 0,
          totalItems: response.pagination?.total || 0,
        });
      } else {
        setStoryData({ data: [], currentPage: 1, totalPages: 0, totalItems: 0 });
        console.error("API Error:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setStoryData({ data: [], currentPage: 1, totalPages: 0, totalItems: 0 });
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let timeoutId = null;

    if (search.length >= 3) {
      timeoutId = setTimeout(() => {
        fetchData(search);
      }, 300);
    } else if (search.length === 0) {
      fetchData();
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [search, fetchData]);

 
  const handlePaginationClick = (pageNo) => {
    fetchData(search, pageNo);
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const renderPagination = () => {
    const { currentPage, totalPages } = storyData;

    return (
      <Pagination className="mt-3 mb-5 justify-content-center">
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            previous
            onClick={() => handlePaginationClick(currentPage - 1)}
          />
        </PaginationItem>

        {[...Array(totalPages)].map((_, index) => {
          const pageNumber = index + 1;
          if (
            pageNumber === 1 ||
            pageNumber === totalPages ||
            (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
          ) {
            return (
              <PaginationItem
                key={pageNumber}
                active={currentPage === pageNumber}
              >
                <PaginationLink
                  onClick={() => handlePaginationClick(pageNumber)}
                >
                  {pageNumber}
                </PaginationLink>
              </PaginationItem>
            );
          }
          if (
            pageNumber === currentPage - 2 ||
            pageNumber === currentPage + 2
          ) {
            return (
              <PaginationItem disabled key={pageNumber}>
                <PaginationLink>...</PaginationLink>
              </PaginationItem>
            );
          }
          return null;
        })}

        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            next
            onClick={() => handlePaginationClick(currentPage + 1)}
          />
        </PaginationItem>
      </Pagination>
    );
  };
  if(!storyData?.data?.length){
    return null;
  }
  return (
    <div className="student-stories-container prac-paper-container" ref={sectionRef}>
        <div className="mb-3 text-center">
          <h1>Question Bank</h1>
          <p>Recently Prepared DoubtQ</p>
        </div>
      {isLoading ? (
        <p className="text-center mt-4">Loading...</p>
      ) : storyData?.data.length > 0 ? (
        <>
          <div className="grid-container-course-st">
            {storyData?.data.map((e, index) => (
              <div key={index} className="grid-course-item story-card py-3 px-3">
                <Link
                  className="text-decoration-none"
                  to={`/course/${e?.university?.universityUrl}/${e.courseUrl}`}
                  state={{ id: "4" }}

                >
                  <div className="course-img-container text-center mb-4">
                    <img className="course-img" src={File} alt="file" style={{width:"90px"}}/>
                  </div>
                  <div className="subtitle-lh-cos mt-2">
                    {e?.courseName?.length > 15
                      ? `${e.courseName.substring(0, 15)}...`
                      : e?.courseName}
                  </div>
                  <div className="dec-lh-cos">
                    {e?.university?.universityName?.length > 30
                      ? `${e.university?.universityName.substring(0, 30)}...`
                      : e?.university?.universityName}
                  </div>
                  <div className="rating-stars-cos">
                    <Rating
                      size={20}
                      initialValue={parseFloat(e.courseRatings)}
                      readonly
                    />
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <div className="float-end me-5">
            {renderPagination()}
          </div>
        </>
      ) : (
        <p className="text-center mt-4">
          {search.length > 0 && search.length < 3
            ? "Please enter at least 3 characters to search"
            : "No results found"}
        </p>
      )}
    </div>
  );
};

export default QuestionBankCompPage;
